<div class="wrapper publisher-app">

  <mat-sidenav-container>
    <mat-sidenav-content>

      <div class="mobile-top-bar d-flex align-items-center d-md-none"
           (scroll)="onScrollEvent($event)"
           [ngClass]=" {'fixed' : (scrollOffset > 0)} ">
        <div class="col-auto w-25 d-flex" (click)="sidenav.toggle()">
          <button mat-icon-button>
            <i class="material-icons">menu</i>
          </button>
        </div>
        <div class="col text-center" (click)="sidenav.toggle()">
          Consumable
        </div>
        <div class="col-auto w-25 d-flex justify-content-end">
          <button mat-icon-button matTooltip="Support" color=""
                  routerLink="/support"
                  routerLinkActive="active"
                  (click)="$event.stopPropagation()">
            <i class="far fa-life-ring"></i>
          </button>
          <button mat-icon-button matTooltip="Logout" color="" (click)="logout()">
            <i class="far fa-sign-out"></i>
          </button>
        </div>
      </div>

      <div class="main">
        <router-outlet></router-outlet>
      </div>

    </mat-sidenav-content>
    <mat-sidenav [mode]="(screenWidth > 768) ? 'side' : 'over'"
                 [opened]="!screenWidth || screenWidth > 768"
                 [class.sideOpened]="sidenav.opened"
                 [class.sideClosed]="!sidenav.opened"
                 #sidenav>

      <div routerLink="/account"
           routerLinkActive="active"
           class="sidenav-header"
           (click)="(screenWidth < 768) ? sidenav.close() : ''">
        <div class="user-icon" title="Account">
          <i class="far fa-user-circle"></i>
        </div>
        <div class="user" title="Account">
          <p class="sidenav-header-username">{{principal.user?.name}}</p>
          <p class="sidenav-header-publisher">{{principal.publisher?.name}}</p>
        </div>
        <div class="ml-auto" (click)="$event.stopPropagation()" routerLink="/account/tipalti-account"
             *ngIf="!principal.publisher?.tipaltiPayable" matTooltip="Tipalti ID not present!">
          <button mat-icon-button color="primary">
            <i class="fas fa-bell-exclamation text-danger"></i>
          </button>
        </div>
      </div>

      <!--<span (click)="logout()">-->
      <!--<i class="far fa-sign-out"></i>-->
      <!--</span>-->

      <!---->
      <ul class="sidenav-menu" (click)="(screenWidth < 768) ? sidenav.close() : ''">
        <li *ngIf="!isIntroCompleted()">
          <a
            routerLink="/welcome"
            routerLinkActive="active">
            <i class="far fa-tachometer-alt"></i>
            <span>Welcome</span>
          </a>
        </li>
        <li>
          <a [class.disabled]="!isIntroCompleted() "
             routerLink="/dashboard"
             routerLinkActive="active">
            <i class="far fa-tachometer-alt"></i>
            <span>Dashboard</span>
          </a>
        </li>
        <li>
          <a [class.disabled]="!isIntroCompleted() "
             routerLink="/sites"
             routerLinkActive="active">
            <i class="far fa-sitemap" aria-hidden="true"></i>
            <span>Sites</span>
          </a>
        </li>
        <!-- leave out for now until we test this internally -bg
        <li>
          <a [class.disabled]="!isIntroCompleted() "
             routerLink="/apps"
             routerLinkActive="active">
            <i class="far fa-sitemap" aria-hidden="true"></i>
            <span>Apps</span>
          </a>
        </li>
        -->
        <li *ngIf="principal.publisher.adTagEnabled || principal.publisher.bidderEnabled">
          <a [class.disabled]="!isIntroCompleted() "
             [routerLink]="productsRouterLink()"
             routerLinkActive="active"
             #rla1="routerLinkActive">
            <i class="far fa-magic" aria-hidden="true"></i>
            <span>Products
              <!--<cm-new-feature-flag expiryDate="2018-06-01" description="Check out new bidders section"></cm-new-feature-flag>-->
            </span>
          </a>
          <ul class="sidenav-submenu" *ngIf="principal.publisher.adTagEnabled && principal.publisher.bidderEnabled">
            <li *ngIf="principal.publisher.types.indexOf('AUDIO_PODCAST') >= 0">
              <a [class.disabled]="!isIntroCompleted() "
                 routerLink="/products/promocast"
                 routerLinkActive="active">
                <span>Promocast
                  <cm-new-feature-flag expiryDate="2019-08-01"
                                       description="NEW">
                  </cm-new-feature-flag>
                </span>
              </a>
            </li>
            <li *ngIf="principal.publisher.types.indexOf('DISPLAY_CLASSIC') >= 0 && principal.publisher.bidderEnabled">
              <a [class.disabled]="!isIntroCompleted() "
                 routerLink="/products/bidder"
                 routerLinkActive="active">
                <span>Bidder
                  <cm-new-feature-flag expiryDate="2019-08-01"
                                       description="NEW">
                  </cm-new-feature-flag>
                </span>
              </a>
            </li>
            <li class="d-none d-md-block" *ngIf="principal.publisher.types.indexOf('DISPLAY_CLASSIC') >= 0 && principal.publisher.adTagEnabled">
              <a [class.disabled]="!isIntroCompleted() "
                 routerLink="/products/ad-tags"
                 routerLinkActive="active">
                <span>Ad tags</span>
              </a>
            </li>
          </ul>
        </li>
        <li *ngIf="principal.publisher.adTagEnabled || principal.publisher.bidderEnabled">
          <a [class.disabled]="!isIntroCompleted() "
             [routerLink]="inventoryRouterLink()"
             #inventory="routerLinkActive"
             routerLinkActive="active">
            <i class="far fa-list" aria-hidden="true"></i>
            <span>Monetize Inventory</span>
          </a>
          <!--<ul class="sidenav-submenu" [hidden]="!inventory.isActive">-->
          <ul class="sidenav-submenu" *ngIf="principal.publisher.adTagEnabled && principal.publisher.bidderEnabled">
            <li *ngIf="principal.publisher.types.indexOf('DISPLAY_CLASSIC') >= 0 && principal.publisher.bidderEnabled">
              <a routerLink="/inventory/bidder"
                 routerLinkActive="active"
                 [class.disabled]="!isIntroCompleted()">
                <span>Bidder
                </span>
              </a>
            </li>
            <li *ngIf="principal.publisher.adTagEnabled">
              <a
                routerLink="/inventory/ad-tags"
                routerLinkActive="active"
                [class.disabled]="!isIntroCompleted()">
                <span>Ad tags</span>
              </a>
            </li>
          </ul>
        </li>

        <li class="d-none d-md-block">
          <a [class.disabled]="!isIntroCompleted() "
             routerLink="/reporting"
             routerLinkActive="active">
            <i class="far fa-chart-line"></i>
            <span>Reporting</span>
          </a>
        </li>
        <li>
          <a [class.disabled]="!isIntroCompleted() "
             routerLink="/ads-txt"
             routerLinkActive="active">
            <i class="far fa-file-alt" aria-hidden="true"></i>
            <span></span>
            <span [matBadgeHidden]="!showAdsTxtAlert" matBadge="." matBadgeOverlap="false"
                  matBadgeSize="small" matBadgePulseOnly>
              Ads.txt
            </span>
          </a>
        </li>
        <li>
          <a [class.disabled]="!isIntroCompleted() "
             routerLink="/blocklist"
             routerLinkActive="active">
            <i class="far fa-shield-alt" aria-hidden="true"></i>
            <span>Blocklist</span>
          </a>
        </li>
        <li>
          <a [class.disabled]="!isIntroCompleted() "
             routerLink="/api"
             routerLinkActive="active">
            <i class="far fa-server" aria-hidden="true"></i>
            <span>API
              <cm-new-feature-flag expiryDate="2019-08-01"
                                   description="NEW">
              </cm-new-feature-flag>
            </span>
          </a>
        </li>
        <!--<li>-->
        <!--<a-->
        <!--routerLink="/support"-->
        <!--routerLinkActive="active">-->
        <!--<i class="far fa-question-circle"></i>-->
        <!--<span>Support</span>-->
        <!--</a>-->
        <!--</li>-->
        <!--<li>-->
        <!--<a [class.disabled]="!isIntroCompleted()"-->
        <!--routerLink="/account"-->
        <!--routerLinkActive="active">-->
        <!--<i class="far fa-user-circle" aria-hidden="true"></i>-->
        <!--<span>Account</span>-->
        <!--</a>-->
        <!--</li>-->
      </ul>
    </mat-sidenav>
  </mat-sidenav-container>
</div>
